import React, { useEffect, useRef, useState } from 'react';
import '../App.css';
import { Modal, Table } from 'react-bootstrap';
import tmImage from '../assets/tm-blue-logo.png';
import { LuMapPin, LuCalendarDays } from "react-icons/lu";
import { DeleteEvents, fetchDropMap, GetAllDrops, isValidate, RemoveDrop } from '../components/services/api';
import { useNavigate } from 'react-router-dom';
import usePagination from '../components/hooks/usePagination';
import Pagination from '../components/Pagination';
import ScreenLoading from '../components/ScreenLoading';
import { MdMargin } from 'react-icons/md';
import { FaTrash } from 'react-icons/fa6';

export default function LiveFeeds() {
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isDrop, setIsDrop] = useState(null);
  const [drops, setDrops] = useState([]);
  const [isValidUser, setIsValidUser] = useState(false);
  const [mapSvg, setMapSvg] = useState("");
  const [isMapLoading, setIsMapLoading] = useState(false);


  // const [intervalSec, setIntervalSec] = useState(() => {
  //   return localStorage.getItem('feed') || '10'
  // });
  const {
    currentPage,
    totalPages,
    currentData,
    goToPage,
    rowsPerPage,
    changeRowsPerPage
  } = usePagination(drops, 10);

  //const intervalRef = useRef(null);
  const navigate = useNavigate();
  const ranOnceRef = useRef(false);
  const timeoutRef = useRef(null);


  useEffect(() => {
    if (ranOnceRef.current) return;
    ranOnceRef.current = true;
    const checkValidation = async () => {
      try {
        const result = await isValidate();

        if (result?.d === true) {
          setIsValidUser(true);
          await fetchData();
        }
        else if (result?.d === false) {
          navigate("/");
        }
        else {
          navigate("/");
        }

      } catch (error) {
        console.error("Validation error:", error);
        navigate("/");
      }
    };
    checkValidation();

    // Clear old interval
    // if (intervalRef.current) {
    //   clearInterval(intervalRef.current);
    //   //intervalRef.current = null;
    // }

    // // Setup new interval
    // if (intervalSec !== "never") {
    //   intervalRef.current = setInterval(() => {
    //     fetchData();
    //   }, Number(intervalSec) * 1000);
    // }

    // return () => {
    //   isMouted = false;
    //   if (intervalRef.current) {
    //     clearInterval(intervalRef.current);
    //   }
    // };

    //[intervalSec, navigate]
  }, [navigate]);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    if (!isValidUser) return;

    const handler = (event) => {
      if (event.data?.type === "NEW_DROPS") {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
          fetchData();
          timeoutRef.current = null;
        }, 500);
      }
    };
    navigator.serviceWorker.addEventListener("message", handler);
    // return () => {
    //   navigator.serviceWorker.removeEventListener("message", handler);
    // };
  }, [isValidUser]);

  useEffect(() => {
    if (!selectedEvent) return;

    const loadMap = async () => {
      try {
        setIsMapLoading(true);
        setMapSvg("");
        const eventId = formateUrl(selectedEvent.eventID);
        const sections = selectedEvent.section;

        const rawMap = await fetchDropMap(eventId, sections);
        setMapSvg(rawMap);
      } catch (err) {
        console.error("Drop map failed:", err);
        setMapSvg("");
      } finally {
        setIsMapLoading(false);
      }
    };

    loadMap();
  }, [selectedEvent]);


  // const radioChanged = (e) => {
  //   const value = e.target.value;
  //   setIntervalSec(value);
  //   localStorage.setItem('feed', value);
  // };

  const fetchData = async () => {
    try {
      const response = await GetAllDrops();
      const data = response?.d;

      if (data) {
        setDrops(Array.isArray(data) ? data : [data]);
      } else {
        setDrops([]);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setDrops([]);
    }
  };

  const formateUrl = (url) => {
    if (!url) return '';
    //const link = url.split("/", "_").pop();
    //const match = url.match(/event\/([^/?]+)/); /^(.*\/event\/[A-Za-z0-9]+)/
    const match = url.match(/event\/([A-Za-z0-9]+?)(?=[_/?#]|$)/);
    return match ? match[1] : '';
  };
  const formateEventUrl = (url) => {
    if (!url) return '';
    //const match = url.match(/^(.*\/event\/[A-Za-z0-9]+)/);

    const isUK = /\/event\/[A-Za-z0-9]+_UK(?=[/?#]|$)/i.test(url);
    const cleaned = url.match(/^(https?:\/\/)?([^\/]+\/event\/[A-Za-z0-9]+)/i);

    if (!cleaned) return url;

    let finalUrl = cleaned[0];

    // agar _UK hai → domain change karo
    if (isUK) {
      finalUrl = finalUrl.replace(
        /ticketmaster\.com/i,
        'ticketmaster.co.uk'
      );
    }
    return finalUrl;
  };
  const ConvertServerTime = (serverTime) => {
    if (!serverTime) return "";
    // Build ISO string from "YYYY/MM/DD HH:mm:ss"
    const actualDate = serverTime.replace(/\//g, "-") ;
    console.log(actualDate);
    const isoString = new Date(actualDate.replace(" ", "T")+ "Z");
    const dateTimeStr = isoString.toLocaleString();
    return dateTimeStr; 
  }
  const RemoveSelectedDrop = async (value) => {
    const res = await DeleteEvents(value);
    if (res && res.d == 'success') {
      console.log("Drop removed successfully");
      setDrops(prev => prev.filter(drops => drops.eventInfoId !== value));
      
    }
  }

  return (
    <main className='main-container'>
      <div className="container my-3">
        <div className='main-title mt-2 justify-content-end align-item-end'>
          {/* <h5>Live Feed</h5> */}
          {/* <div className="feed-button d-flex align-items-baseline gap-1 p-2">
            <p className='mx-2'>Update live feeds every:</p>
            {['10', '20', '60', 'never'].map((val) => (
              <div className="form-check form-check-inline" key={val}>
                <input
                  className="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  value={val}
                  checked={intervalSec === val}
                  onChange={radioChanged}
                  id={`inlineRadio${val}`}
                />
                <label className="form-check-label" htmlFor={`inlineRadio${val}`}>
                  {val === 'never' ? 'Never' : `${val} sec`}
                </label>
              </div>
            ))}
          </div> */}

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            goToPage={goToPage}
            rowsPerPage={rowsPerPage}
            changeRowsPerPage={changeRowsPerPage}
          />

        </div>
        {/* EVENT CARD LIST */}
        {currentData.map((drops, i) => (
          <div
            key={i}
            className="p-3 panel-container d-flex justify-content-between align-items-center mb-1"
            style={{ cursor: "pointer" }}
            // onClick={() => {
            //   if (drops && Object.keys(drops).length > 0) {
            //     setSelectedEvent(drops);
            //   }}}
            onClick={() => setSelectedEvent(drops)}
          >
            <div>
              <h6 className='mb-2'>{drops.eventName}</h6>
              <span className='d-flex align-items-center gap-1'>
                <LuMapPin />
                <p>{drops.eventVenue}</p>
              </span>
              <span className='d-flex align-items-center gap-1'>
                <LuCalendarDays />
                <p className="ml-2">{drops.eventDate}</p>
              </span>
                <div className='d-flex align-items-center gap-3'>
                  <small>Release On: {ConvertServerTime(drops.updatedOn)}</small>
                  <button className='btn btn-danger px-2 py-1' onClick={(e) => {e.stopPropagation(); RemoveSelectedDrop(drops.eventInfoId);}} >
                    <FaTrash style={{fontSize: '14px', paddingBottom: '2px'}} /> Remove Event
                  </button>
                </div>
            </div>

            <div>
              <img src={tmImage} alt="Ticketmaster Logo" width="200px" style={{ borderRadius: "12px" }} /> 
            </div>
          </div>

        ))}

        {/* MODAL (POPUP) */}
        <Modal show={!!selectedEvent} onHide={() => setSelectedEvent(null)} size="xl" centered backdrop="dynamic" >
          <Modal.Body className="p-4">
            <button type="button"
                className="btn-close d-flex ms-auto"
                data-bs-dismiss="modal"
                aria-label="Close" onClick={x => setSelectedEvent(null)} style={{fontSize: "0.9rem"}}>
            </button>
            {selectedEvent && Object.keys(selectedEvent).length > 0 && (
              <>
                {/* BODY 2-COLUMN LAYOUT */}
                <div className="mt-1 row">

                  {/* LEFT SIDE */}
                  <div className="col-7 drop-data">
                    <div>
                      <h4><strong>{selectedEvent.eventName || "N/A"}</strong></h4>
                      <p><span className='d-flex align-items-center gap-1'>
                        <LuCalendarDays />{selectedEvent.eventDate || "-"} </span></p>
                      <p><span className='d-flex align-items-center gap-1'>
                        <LuMapPin />{selectedEvent.eventVenue || "-"}</span></p>
                    </div>
                    <a href={formateEventUrl(selectedEvent.eventID)} target="_blank" rel="noreferrer">
                      {formateEventUrl(selectedEvent.eventID)}
                    </a>
                    <hr />
                    <Table striped bordered hover size="sm">
                      <thead>
                        <tr>
                          <th colSpan={2}>Ticket Type</th>
                          <th colSpan={2}>Section</th>
                          <th colSpan={2}>Row</th>
                          <th colSpan={2} className='td-wrap' >Seats Count</th>
                          <th colSpan={3}>Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan={2}>{selectedEvent.TicketType || "-"}</td>
                          <td className='td-wrap' colSpan={2}>{selectedEvent.section || "-"}</td>
                          <td colSpan={2}>{selectedEvent.row || "-"}</td>
                          <td colSpan={2}>{selectedEvent.DropCount || "-"}</td>
                          <td colSpan={3} className='td-wrap'>${selectedEvent.price || "0"}</td>
                        </tr>
                        {/* )) */}

                      </tbody>
                    </Table>
                    <strong>Release Time: {ConvertServerTime(selectedEvent.updatedOn)}</strong>                  
                  </div>

                  {/* RIGHT SIDE */}
                  <div className="col-5">
                    {/* <div dangerouslySetInnerHTML={{ __html: mapSvg || "" }} width={'450px'} height={'350px'} /> */}

                    {isMapLoading && (
                      <div style={{ height: "350px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <ScreenLoading />
                      </div>
                    )}

                    {!isMapLoading && mapSvg && (
                      <img
                        src={`data:image/png;base64,${mapSvg}`}
                        alt="Event Map"
                        width="450"
                        height="350"
                        style={{ borderRadius: "8px" }}
                      />
                    )}
                  </div>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>
      </div>
    </main>
  )
}